module.exports = __webpack_public_path__ + "static/img/khfw26.041b752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw26.png
// module id = eFTt
// module chunks = 3